import { JSX } from 'react'

import { IconProps } from '../../icon'

const EdubookLandscapeOrange: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 35}
    id={id}
    stroke={stroke}
    viewBox='0 0 111 35'
    width={width || 111}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M79.6698 35L56.306 29.6091L57.2621 26.3136L80.6259 31.6943L79.6698 35Z'
      fill='#FF6A00'
    />
    <path
      d='M79.6291 35L102.993 29.6091L102.037 26.3136L78.673 31.6943L79.6291 35Z'
      fill='#FF6A00'
    />
    <path
      d='M4.26877 3.61087H14.013L13.4536 0.742523H0.190002V3.61087H4.26877Z'
      fill='#FF6A00'
    />
    <path
      d='M11.1141 11.6666L10.5242 8.76779H4.26877H0.190002V11.6666H4.26877H11.1141Z'
      fill='#FF6A00'
    />
    <path
      d='M13.4536 17.0474H4.26877H0.190002V19.8852H14.0435L13.4536 17.0474Z'
      fill='#FF6A00'
    />
    <path
      d='M28.8837 19.8852H26.9715L26.1272 18.6443C24.927 19.6919 23.6149 20.2209 22.1807 20.2209C20.0549 20.2209 18.3868 19.5801 17.156 18.2883C15.9253 17.0067 15.315 15.2572 15.315 13.0602C15.315 11.6362 15.5896 10.3749 16.149 9.28654C16.6983 8.1982 17.5018 7.35396 18.5597 6.75384C19.6073 6.15373 20.8584 5.84858 22.3028 5.84858C22.7503 5.84858 23.2284 5.92996 23.7369 6.0927C24.2455 6.25545 24.7337 6.46904 25.2016 6.75384V0.305139L28.8939 0V19.875L28.8837 19.8852ZM22.3231 17.0982C22.8114 17.0982 23.2894 17.0067 23.7471 16.8134C24.2048 16.6303 24.6931 16.3455 25.2016 15.9692V10.1409C24.7134 9.72391 24.2455 9.42894 23.798 9.25603C23.3504 9.07294 22.8622 8.99158 22.3333 8.99158C21.3365 8.99158 20.5533 9.36792 19.9633 10.1308C19.3836 10.8936 19.0886 11.8701 19.0886 13.0703C19.0886 14.2706 19.3734 15.247 19.943 15.9895C20.5126 16.732 21.306 17.0982 22.3231 17.0982Z'
      fill='#FF6A00'
    />
    <path
      d='M37.7837 17.2915C38.4245 17.2915 39.0247 17.1491 39.5841 16.8541C40.1435 16.5591 40.764 16.1726 41.4455 15.6844V6.22495H45.1072V19.8852H42.7169L42.0964 18.4205C41.2522 19.0206 40.3469 19.4885 39.3908 19.8242C38.4347 20.1598 37.5803 20.3328 36.8276 20.3328C35.0985 20.3328 33.8881 19.8445 33.1964 18.8681C32.5048 17.8916 32.1589 16.5286 32.1589 14.7893V6.22495H35.8206V14.6164C35.8206 15.4606 35.9936 16.1218 36.3394 16.5897C36.6852 17.0576 37.1734 17.2915 37.7939 17.2915H37.7837Z'
      fill='#FF6A00'
    />
    <path
      d='M72.3565 20.2209C70.8918 20.2209 69.6102 19.9259 68.5117 19.3461C67.4132 18.7663 66.569 17.9323 65.9587 16.8541C65.3586 15.7759 65.0534 14.5147 65.0534 13.0703C65.0534 11.626 65.3484 10.3545 65.9587 9.2662C66.5588 8.17785 67.4132 7.33362 68.5117 6.74368C69.6102 6.15373 70.8918 5.85876 72.3565 5.85876C73.8212 5.85876 75.1028 6.15374 76.2014 6.73351C77.2999 7.31328 78.1441 8.14734 78.7544 9.22552C79.3545 10.3037 79.6596 11.565 79.6596 13.0093C79.6596 14.4536 79.3545 15.7251 78.7544 16.8134C78.1543 17.9018 77.2999 18.746 76.2014 19.336C75.1028 19.9259 73.8212 20.2209 72.3565 20.2209ZM75.8759 13.0093C75.8759 11.8294 75.5504 10.8631 74.8892 10.1104C74.2281 9.35774 73.3839 8.9814 72.3565 8.9814C71.3292 8.9814 70.5053 9.36792 69.834 10.1308C69.1627 10.9038 68.8372 11.8803 68.8372 13.0602C68.8372 14.2401 69.1627 15.2063 69.8238 15.959C70.485 16.7117 71.3292 17.0881 72.3565 17.0881C73.3839 17.0881 74.2077 16.7015 74.879 15.9285C75.5402 15.1555 75.8759 14.179 75.8759 12.9991V13.0093Z'
      fill='#FF6A00'
    />
    <path
      d='M88.3461 20.2209C86.8814 20.2209 85.5998 19.9259 84.5013 19.3461C83.4028 18.7663 82.5585 17.9323 81.9482 16.8541C81.3481 15.7759 81.043 14.5147 81.043 13.0703C81.043 11.626 81.338 10.3545 81.9482 9.2662C82.5484 8.17785 83.4028 7.33362 84.5013 6.74368C85.5998 6.15373 86.8814 5.85876 88.3461 5.85876C89.8108 5.85876 91.0924 6.15374 92.1909 6.73351C93.2894 7.31328 94.1336 8.14734 94.7439 9.22552C95.344 10.3037 95.6492 11.565 95.6492 13.0093C95.6492 14.4536 95.344 15.7251 94.7439 16.8134C94.1438 17.9018 93.2894 18.746 92.1909 19.336C91.0924 19.9259 89.8108 20.2209 88.3461 20.2209ZM91.8654 13.0093C91.8654 11.8294 91.5399 10.8631 90.8788 10.1104C90.2176 9.35774 89.3734 8.9814 88.3461 8.9814C87.3188 8.9814 86.4949 9.36792 85.8236 10.1308C85.1523 10.9038 84.8268 11.8803 84.8268 13.0602C84.8268 14.2401 85.1522 15.2063 85.8134 15.959C86.4745 16.7117 87.3188 17.0881 88.3461 17.0881C89.3734 17.0881 90.1973 16.7015 90.8686 15.9285C91.5298 15.1555 91.8654 14.179 91.8654 12.9991V13.0093Z'
      fill='#FF6A00'
    />
    <path
      d='M101.355 15.4098V19.8852H97.7242V0.315332L101.355 0.0101929V11.2191L107.214 5.83844L109.269 8.43216L105.444 11.7786L110.459 19.8852H106.258L102.82 14.1078L101.355 15.3996V15.4098Z'
      fill='#FF6A00'
    />
    <path
      d='M60.7 9.50015C62.0732 8.43215 62.7547 7.29294 62.7547 6.09271C62.7547 4.25167 62.2054 2.89886 61.0967 2.03429C59.988 1.16971 58.4521 0.742523 56.4789 0.742523H49.0435V3.78378H55.9398C56.9162 3.78378 57.6486 3.96687 58.147 4.32287C58.6454 4.67887 58.8895 5.28916 58.8895 6.15373C58.8895 6.94711 58.5742 7.53706 57.9334 7.94392C57.2926 8.35078 56.4382 8.5542 55.3702 8.5542H49.0334V11.5141H56.8654C57.7808 11.5141 58.5132 11.7582 59.0523 12.2464C59.5913 12.7347 59.8558 13.4162 59.8558 14.3011C59.8558 15.125 59.5609 15.7658 58.9811 16.2133C58.4013 16.6609 57.6079 16.8846 56.6111 16.8846H49.0334V19.8954H56.8857C58.9505 19.8954 60.5882 19.397 61.8087 18.39C63.0293 17.383 63.6396 16.0099 63.6396 14.2604C63.6396 12.1244 62.653 10.5376 60.6797 9.50015H60.7Z'
      fill='#FF6A00'
    />
  </svg>
)

export default EdubookLandscapeOrange
